import { userService } from "./user.service";
import { serverUrl } from "../_constants";
import { history } from "../_helpers/history";
import { intlLocale } from "../_helpers/language";

function failure(onError) {
  return (error) => {
    if (error?.response?.status === 401) history.push("/login");
    if (onError) onError(error);
  };
}

export const billingService = {
  createPremiumOrder(conferenceId, onSuccess, onError) {
    userService.postWrapper(`api/conference/${conferenceId}/premium`, {},
      (response) => onSuccess(response.data), failure(onError));
  },
  createInvoice(sum, onSuccess, onError) {
    userService.postWrapper("api/balance/invoice", { sum },
      (response) => onSuccess(response.data), failure(onError));
  },
  getOrder(orderId, onSuccess, onError) {
    userService.getWrapper(`api/order/${orderId}`,
      (response) => onSuccess(response.data), failure(onError));
  },
};

function storageKey(kind, userId, conferenceId) {
  return `navic_payment:${serverUrl}:${userId}:${kind}:${conferenceId || 0}`;
}

export function readPaymentOrder(kind, userId, conferenceId) {
  if (!userId) return null;
  try {
    return JSON.parse(localStorage.getItem(storageKey(kind, userId, conferenceId))) || null;
  } catch (_) {
    return null;
  }
}

export function savePaymentOrder(kind, userId, order, conferenceId) {
  if (!userId) return;
  // Платёжные redirect и order_string не кешируем: повторная оплата всегда через POST.
  const { order_id, type, status, payment_method, cost, currency, months,
    conference_id, premium_until, invoice_url } = order;
  try {
    localStorage.setItem(storageKey(kind, userId, conferenceId), JSON.stringify({
      order_id, type, status, payment_method, cost, currency, months,
      conference_id, premium_until, invoice_url,
    }));
  } catch (_) {
    // Недоступное хранилище не должно мешать самой оплате.
  }
}

export function isPremiumOrder(order, conferenceId) {
  return order?.type === "premium_conference" && Number(order.conference_id) === Number(conferenceId)
    && Number(order.order_id) > 0;
}

export function isBalanceInvoice(order) {
  return order?.type === "service" && order.payment_method === "invoice"
    && Number(order.order_id) > 0 && typeof order.invoice_url === "string" && !!order.invoice_url;
}

export function normalizePaymentSum(value, max = 999999.99) {
  const sum = String(value).trim().replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(sum)) return null;
  const amount = Number(sum);
  if (!Number.isFinite(amount) || amount <= 0 || (max !== null && amount > max)) return null;
  return amount.toFixed(2);
}

export function paymentPrice(amount, currency) {
  if (amount == null || !currency || !Number.isFinite(Number(amount))) return "";
  try {
    return new Intl.NumberFormat(intlLocale(), { style: "currency", currency }).format(Number(amount));
  } catch (_) {
    return `${amount} ${currency}`;
  }
}

export function premiumUntilDate(until) {
  if (!until || !Number.isFinite(new Date(until).getTime())) return "";
  return new Intl.DateTimeFormat(intlLocale(), {
    day: "numeric", month: "long", year: "numeric",
  }).format(new Date(until));
}
